import React, { createContext, useState } from "react";

export const signupContext = createContext(null);

const SignupContext = ({ children }) => {
  const [signup, setSignup] = useState(null);
  const [formData, setFormData] = useState({ name: "", email: "" });
  const [isTypeSelect, setIsTypeSelect] = useState("individual");
  const [qrData, setQrData] = useState("");
  const [paymentKey, setPaymentKey] = useState("");
  const [amount, setAmount] = useState("");
  const [orderId, setOrderId] = useState("");
  const [currency, setCurrency] = useState("");
  const [paymentObj, setPaymentObj] = useState({});
  const [storageBalance, setStorageBalance] = useState(0);
  const [user, setUser] = useState("");
  const [orgnization, setOrgnization] = useState("");
  const [sdk, setSdk] = useState(null);
  const [selectedPlanData, setSelectedPlanData] = useState(null);
  const [couponEmail, setCouponEmail] = useState("");

  const resetSignupData = () => {
    setSignup(null);
    setFormData({ name: "", email: "" });
    setIsTypeSelect("individual");
    setQrData("");
    setPaymentKey("");
    setAmount("");
    setOrderId("");
    setCurrency("");
    setPaymentObj({});
    setStorageBalance(0);
    setUser("");
    setOrgnization("");
    setSdk(null);
    setSelectedPlanData(null);
    setCouponEmail("");
  };

  return (
    <signupContext.Provider
      value={{
        signup,
        setSignup,
        formData,
        setFormData,
        isTypeSelect,
        setIsTypeSelect,
        qrData,
        setQrData,
        paymentKey,
        setPaymentKey,
        amount,
        setAmount,
        orderId,
        setOrderId,
        currency,
        setCurrency,
        paymentObj,
        setPaymentObj,
        storageBalance,
        setStorageBalance,
        user,
        setUser,
        orgnization,
        setOrgnization,
        sdk,
        setSdk,
        selectedPlanData,
        setSelectedPlanData,
        couponEmail,
        setCouponEmail,
        resetSignupData
      }}
    >
      {children}
    </signupContext.Provider>
  );
};

export default SignupContext;
